import { FETCH_USER_POSTS_BEGIN,
  FETCH_USER_POSTS_SUCCESS,
  FETCH_USER_POSTS_FAILURE,
  SET_QUERY, SET_CURRENT_ITEM, UPDATE_USER_OFFER_BEGIN,
  UPDATE_USER_OFFER_SUCCESS,
  UPDATE_USER_OFFER_FAILURE,
  UPDATE_CAMPAIGN_COUNTERS,
  SELECT_OBJECT,
  UNSELECT_OBJECT,
  SELECT_ALL_POSTS,
  DESELECT_ALL,
  SET_CAROUSEL_ID
} from '../actions/userPostCarousel';

const initialState = {
  items: [],
  query: null,
  currentItem: {},
  isLastPage: false,
  loading: false,
  error: null
};

export default function userPostCarousel(state = {}, action) {
  let currentItem, items, currentItemPosition, showLoading, selectedObjectIds;
  let objects_state, previousState;
  let carouselId = action.opts && action.opts.carouselId || state.carouselId;
  if (carouselId) {
    previousState = state[carouselId];
    if (!previousState) {
      previousState = initialState;
    }
  }
  switch (action.type) {
  case SET_CAROUSEL_ID:
    return {
      ...state,
      carouselId: action.carouselId
    };
  case FETCH_USER_POSTS_BEGIN:
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      loading: !action.opts.concat,
      error: null,
      fetchingData: true
    };
    return {
      ...state,
      ...objects_state,
      carouselId
    };


  case FETCH_USER_POSTS_SUCCESS:
    // All done: set loading "false".
    // Also, replace the items with the ones from the server
    let draftResponse = action.payload.posts;
    items = (action.opts.concat ? previousState.items.concat(draftResponse.items) : draftResponse.items);

    // Remove possible dublicates when default_id param is set
    const ids = items.map(({ id }) => id);
    items = items.filter(({ id }, index) => !ids.includes(id, index + 1));

    currentItem = (previousState.currentItem.id && !action.opts.resetCurrentItem) ? previousState.currentItem : Object.assign(draftResponse.items[0] || {});
    if (previousState.currentItem.id && !action.opts.resetCurrentItem) {
      currentItem = previousState.currentItem;
      currentItemPosition = previousState.currentItemPosition;
    } else {
      currentItem = Object.assign(draftResponse.items[0] || {});
      currentItemPosition =  0;
    }
    let query = { ...previousState.query, ...action.opts.query, cursor: draftResponse.cursor, nextCursor: draftResponse.next_cursor };
    objects_state = {};
    objects_state[carouselId] =  {
      ...previousState,
      loading: false,
      items,
      isLastPage: draftResponse.last_page,
      query,
      itemRepresenter: (previousState.itemRepresenter || action.opts.itemRepresenter),
      currentItem,
      selectedObjectIds: [],
      currentItemPosition,
      fetchingData: false
    };
    return {
      ...state,
      ...objects_state,
      carouselId
    };
  case FETCH_USER_POSTS_FAILURE:
    // The request failed, but it did stop, so set loading to "false".
    // Save the error, and we can display it somewhere
    // Since it failed, we don't have items to display anymore, so set it empty.
    // This is up to you and your app though: maybe you want to keep the items
    // around! Do whatever seems right.
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      loading: false,
      error: action.payload.error,
      items: [],
      fetchingData: false
    };
    return {
      ...state,
      ...objects_state
    };
  case SET_QUERY:
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      query: action.query
    };
    return {
      ...state,
      ...objects_state
    };
  case SET_CURRENT_ITEM:
    let itemPosition = previousState.items.indexOf(action.item);
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      selectedObjectIds: [],
      currentItem: action.item,
      currentItemPosition: itemPosition
    };
    return {
      ...state,
      ...objects_state
    };
  case SELECT_OBJECT:
    selectedObjectIds =  [].concat(previousState.selectedObjectIds || []);
    selectedObjectIds.push(action.objectId);
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      selectedObjectIds
    };
    return {
      ...state,
      ...objects_state
    };
  case SELECT_ALL_POSTS:
    selectedObjectIds =  action.objectIds;
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      selectedObjectIds
    };
    return {
      ...state,
      ...objects_state
    };
  case UNSELECT_OBJECT:
    objects_state = {};
    selectedObjectIds =  [].concat(previousState.selectedObjectIds || []);
    selectedObjectIds.splice(selectedObjectIds.indexOf(action.objectId), 1);
    objects_state[carouselId] = {
      ...previousState,
      selectedObjectIds
    };
    return {
      ...state,
      ...objects_state
    };
  case DESELECT_ALL:
    objects_state = {};
    selectedObjectIds =  [];
    objects_state[carouselId] = {
      ...previousState,
      selectedObjectIds
    };
    return {
      ...state,
      ...objects_state
    };
  case UPDATE_USER_OFFER_BEGIN:
    showLoading = { ...(previousState.showLoading || {}) };
    showLoading[action.opts.id] = true;
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      showLoading,
      showError: null
    };
    return {
      ...state,
      ...objects_state
    };
  case UPDATE_USER_OFFER_SUCCESS:
    currentItem = action.data;
    ({ items, currentItemPosition } = previousState);
    items[currentItemPosition] = currentItem;
    showLoading = { ...(previousState.showLoading || {}) };
    showLoading[action.opts.id] = false;
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      showLoading,
      showError: null,
      currentItem,
      items
    };
    return {
      ...state,
      ...objects_state
    };
  case UPDATE_USER_OFFER_FAILURE:
    showLoading = { ...(previousState.showLoading || {}) };
    showLoading[action.opts.id] = false;
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      showLoading,
      showError: action.payload.error,
    };
    return {
      ...state,
      ...objects_state
    };
  case UPDATE_CAMPAIGN_COUNTERS:
    objects_state = {};
    objects_state[carouselId] = {
      ...previousState,
      counters: action.counters,
    };
    return {
      ...state,
      ...objects_state
    };
  default:
    // ALWAYS have a default case in a reducer
    return state;
  }
}
